<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">
      Table exporting
    </v-card-title>
    <v-card-text>
      The upload is very large, the file will be prepared separately. Go to the
      Downloads page to get the report when it's ready.
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn to="/cabinet/downloads" text>
        Downloads
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="close()">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "DownloadDialog",
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped></style>
